import { CircleMarker, Tooltip, Popup } from "react-leaflet";
import { useState, useEffect } from "react";
import Button from '@mui/material/Button';
import L from "leaflet";
import Moment from 'react-moment';
import moment from 'moment';
import authHeader from "../../services/auth-header";

import { useTranslation } from "react-i18next";

const api = require("../../api/names.js");


function DetectorMarker(props){

  const { t } = useTranslation("common");

  const [parkingID, setParkingID] = useState(props.parkingID);
  const [lat, setLat] = useState(props.lat);
  const [lon, setLon] = useState(props.lon);
  const [color, setColor] = useState(props.color);
  const [fillColor, setFillColor] = useState(props.color);
  const [radius, setRadius] = useState(props.radius);

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);

  useEffect(() => {

    myfun();
    const interval = setInterval(() => {
      myfun();
    }, 5000);
    return () => {
      clearInterval(interval);
    };
  }, []);



  const myfun = () => {
    var url = api.baseUrl+'/detectorsCurrentValues/ByAddress/';
    url += props.address;
    //console.log(url);
    
    fetch(url, {
  method: 'get',
  headers: authHeader()
  })
    .then(res => res.json())
    .then(
      (result) => {
        if(result[0].isBusy == "0")
        {
          setColor("green");
          setFillColor("green");
        }
        else if(result[0].isBusy == "1")
        {
          setColor("red");
          setFillColor("red");
        }

        if(result[0].type == "1")
        {
          setColor("#1D94E6");
        }
        else if(result[0].type == "2")
        {
          setColor("#2BA70A");
        }



        //console.log(result);
        setIsLoaded(true);
        setItems(result);
      },
      (error) => {
        setIsLoaded(true);
        setError(error);
      }
    )


    setRadius(5);
    //setLat(lat + 0.0001);
    //setLon(lon + 0.0001);
  /*  if(color == "green")
    {
      setColor("red");
      setRadius(4);
    }
    else {
      setColor("green");
      setRadius(1);
    }*/


  }
  return (

      <CircleMarker

        center={[lat, lon]}
        pathOptions={{ color: color, opacity: 0.8, fillColor: fillColor, fillOpacity: 0.6 }}
        radius={radius}
      >

      <Tooltip>{items.map(item => (
        <div>
        {item.address}
        </div>
      ))}</Tooltip>
      <Popup>{items.map(item => (
        <div>
          {t('marker.address')}{item.address} <br />
          {t('marker.isbusy')}{item.isBusy} <br />
          {/*  Radar: {item.radar} <br/>
        X: {item.x} <br/>
        Y: {item.y} <br/>
        RSSI: {item.detectorsMetadatum.rssi} <br/>
        SNR: {item.detectorsMetadatum.snr} <br/>
        Counter: {item.detectorsMetadatum.counter} <br/>*/}
          {t('marker.frametime')}<Moment format="HH:mm:ss - DD/MM/YYYY" unix>{item.timestamp / 1000}</Moment><br />
          {t('marker.enter')}<Moment format="HH:mm:ss - DD/MM/YYYY" unix>{item.entryTimestamp / 1000}</Moment><br />
          {t('marker.leave')}<Moment format="HH:mm:ss - DD/MM/YYYY" unix>{item.exitTimestamp / 1000}</Moment><br />
          <Button href={'/detectorDetails/' + parkingID + '/' + item.address} variant="outlined" >{t('detectorsbp.his')}</Button>
        </div>
      ))}</Popup>
      </CircleMarker>

  );
};

export default DetectorMarker;
